import { Field, Form, Formik } from "formik";
import useSchema from "hooks/useSchema";
import { getMultipleBillActions, navigateBillAction } from "pages/creditBills/utils/actionMaker";
import Button from "pages/_components/Button";
import Selector from "pages/_components/fields/formik/Selector";
import { bool, instanceOf, string } from "prop-types";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { FORM_ID } from "util/creditBills";
import * as Yup from "yup";

const MultipleActionSelector = ({ selectedRows, tabOption, isDesktop }) => {
    const { stringRequired } = useSchema();
    const dispatch = useDispatch();
    const multipleOptions = getMultipleBillActions(selectedRows, tabOption);
    const validationSchema = Yup.object().shape({ action: stringRequired });

    const handleSubmit = (values) => {
        navigateBillAction(values.action, selectedRows, dispatch, tabOption);
    };

    return (
        <>
            {selectedRows.length > 0 && (
                <Formik initialValues={{ action: "" }} onSubmit={handleSubmit} validationSchema={validationSchema}>
                    {({ values }) => (
                        <Form className={isDesktop ? "box box-border-soft mb-6" : "mb-6"}>
                            <Row className="selector-operations align-items-center">
                                <Col xs={12} md={5}>
                                    <Field
                                        idForm={FORM_ID}
                                        name="action"
                                        component={Selector}
                                        options={multipleOptions}
                                        hideLabel
                                        className="m-0"
                                    />
                                </Col>

                                {isDesktop && (
                                    <Col xs={12} md={2} mdOffset={10} className="flex align-items-center">
                                        <Button
                                            type="submit"
                                            className="btn-outline"
                                            label="global.accept"
                                            disabled={!values.action}
                                        />
                                    </Col>
                                )}
                            </Row>
                            {!isDesktop && (
                                <Row className="selector-operations">
                                    <Col xs={12} md={2}>
                                        <Button
                                            type="submit"
                                            className="btn-outline"
                                            label="global.accept"
                                            disabled={!values.action}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </Form>
                    )}
                </Formik>
            )}
        </>
    );
};

MultipleActionSelector.propTypes = {
    selectedRows: instanceOf(Array).isRequired,
    tabOption: string.isRequired,
    isDesktop: bool.isRequired,
};

export default MultipleActionSelector;
